import { Button, Image, Paragraph } from '@app/shared/ui/atoms/Common';
import { pandaHand } from '@app/assets';
import { PulsingGlowWrapper, SettlementImage } from '@app/shared/ui/molecules/Home';
import { Modal } from '@app/shared/ui/organisms/Common/Modal';
import { Settlement } from '@app/store/slices/settlements/settlementsTypes';
import { t } from 'i18next';

interface BuySettlementModalProps {
  settlement: Settlement;
  onPurchase: () => void;
  isPurchasingSettlement: boolean;
  textTKey: string;
  isOpen: boolean;
}

export const BuySettlementModal = ({
  settlement,
  onPurchase,
  isPurchasingSettlement,
  textTKey,
  isOpen,
}: BuySettlementModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      featuredImg={
        <div className="relative">
          <Image src={pandaHand} className="size-[80px] absolute -left-[25%] top-[35%] z-10" />
          <PulsingGlowWrapper borderWidth={8} pulsationClassName="top-[14%] left-[15%]">
            <SettlementImage
              imageUrl={settlement.imageUrl ?? ''}
              name={settlement.name ?? ''}
              className="static size-[150px]"
            />
          </PulsingGlowWrapper>
        </div>
      }
      contentClassName="bg-background shadow-blue"
      displayCloseButton={false}
    >
      <Paragraph>{t(textTKey, { title: settlement.name })}</Paragraph>

      <Button onClick={onPurchase} disabled={isPurchasingSettlement} className="animate-pulse-beat">
        {isPurchasingSettlement ? t('common.wait') : t('common.open')}
      </Button>
    </Modal>
  );
};
